export default function CTASection() {
  return (
    <section className="relative w-full min-h-[400px] md:min-h-[500px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20airy%20modern%20workspace%20with%20open%20laptop%20on%20light%20wood%20desk%2C%20warm%20cream%20walls%2C%20soft%20natural%20light%20through%20sheer%20curtains%2C%20minimalist%20interior%2C%20editorial%20photography%2C%20clean%20fresh%20productive%20atmosphere%2C%20neutral%20warm%20tones&width=1600&height=900&seq=cta-bg-v2-06&orientation=landscape"
          alt="Get the full Pandabuy Sheet comparison list"
          title="Pandabuy Sheet — All Categories Updated Daily"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight">
              Get the Full List
            </h2>
            <p className="mt-3 text-sm md:text-base text-white/85 max-w-md leading-relaxed">
              All categories updated daily. One link to every best deal across 14 product categories — completely free.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 text-sm font-semibold rounded-full bg-white text-foreground-950 hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Pandabuy Sheet</span>
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950 text-white">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 text-sm font-semibold rounded-full border border-white/60 text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}